import { TYPE_QUESTIONS, removeAccentsAndConvertLowercase } from "@educaplay/core";
import { QUESTION_TYPE } from "./constants"

export function validateTextQuestion({ sortedAnswered, correctAnswers, isCaseSensitive }) {
    if (!sortedAnswered) return false;
    if (isCaseSensitive) {
        //Si es sensible a Mayusculas y Acentos
        return correctAnswers.includes(sortedAnswered);
    }

    //No es sensible a Mayusculas y Acentos
    const formattedAnswer = removeAccentsAndConvertLowercase(sortedAnswered);
    for (let i = 0; i < correctAnswers.length; i++) {
        if (formattedAnswer === removeAccentsAndConvertLowercase(correctAnswers[i])) {
            return true
        }
    }
    return false;
}

export function getFilteredSlicePoints(slicePointsPosition) {
    const leftCounters = {};
    const updatedItems = slicePointsPosition.map(item => {
        if (leftCounters[item.left] === undefined) {
            leftCounters[item.left] = 0;
        } else {
            leftCounters[item.left] += 1;
        }

        return {
            ...item,
            left: item.left + leftCounters[item.left]
        };
    });
    return updatedItems;
}

export function validateSingleQuestion({ sortedAnswered, correctAnswers }) {
    return correctAnswers.includes(sortedAnswered);
}

export function validateMultiQuestions({ sortedAnswered, correctAnswers }) {
    if (sortedAnswered.length !== correctAnswers.length) return false;
    return correctAnswers.every((entry, index) => entry === sortedAnswered[index]);
}

export function countAnswers({ sortedAnswered, correctAnswers, numberQuestions }) {
    if (!sortedAnswered || sortedAnswered.length === 0) {
        return { correct: 0, incorrect: numberQuestions };
    }

    const correctCount = sortedAnswered.filter(answer => correctAnswers.includes(answer)).length;
    const incorrectCount = Math.max(correctAnswers.length - correctCount, sortedAnswered.length - correctCount);
    return { correct: correctCount, incorrect: incorrectCount };
}

export function calculateCasePoints({ sortedAnswered, correctAnswers, question, questionType, points, isCaseSensitive, penalty }) {

    switch (questionType) {

        case QUESTION_TYPE.MultiQuestion: {
            if (validateMultiQuestions({ sortedAnswered, correctAnswers })) return points;
            const numberQuestions = question.RESPUESTAS.length;
            const count = countAnswers({ sortedAnswered, correctAnswers, numberQuestions });
            const portionPoint = points / correctAnswers.length;
            const resultPoints = Math.max((portionPoint * count.correct) - (portionPoint * count.incorrect), 0);
            return resultPoints + penalty;
        }

        case QUESTION_TYPE.SingleQuestion: {
            if (validateSingleQuestion({ sortedAnswered, correctAnswers })) return points;
            return penalty;
        }

        case QUESTION_TYPE.TextQuestion: {
            if (validateTextQuestion({ sortedAnswered, correctAnswers, isCaseSensitive })) return points;
            return penalty;
        }

        default: {
            return 0;
        }

    }
}

export function checkTypeAnswer({ sortedAnswered, questionType, correctAnswers, isCaseSensitive }) {
    switch (questionType) {

        case TYPE_QUESTIONS.Selection: {
            if (Array.isArray(sortedAnswered)) {
                return validateMultiQuestions({ sortedAnswered, correctAnswers });
            }
            return validateSingleQuestion({ sortedAnswered, correctAnswers });
        }

        case TYPE_QUESTIONS.Text: {
            return validateTextQuestion({ sortedAnswered, correctAnswers, isCaseSensitive });
        }


        default: {
            return false;
        }

    }

}

export function getAlphabetLetter(index) {
    if (index >= 0 && index < 26) {
        const AsciiCodeA = 'A'.charCodeAt(0);
        const letter = String.fromCharCode(AsciiCodeA + index);
        return letter;
    }
}

export function giveAnswerStyles(answers, correctAnswers, answersSelected, typeQuestion) {
    return answers.reduce((acc, answer) => {
        const isUserAnswer = typeQuestion === QUESTION_TYPE.SingleQuestion ? answer.id === answersSelected : answersSelected.includes(answer.id);
        const userAnswerStyleValue = correctAnswers.includes(answer.id) ? 'correct' : 'wrong';
        return {
            ...acc,
            [answer.id]: isUserAnswer ? userAnswerStyleValue : '',
        }
    }, {});
}

export const getSequence = (secuences, progress) => {
    return secuences.find((secuence, index) => {
        if (index === secuences.length - 1) return true

        return progress >= secuence.timeAppear && progress < secuences[index + 1].timeAppear;
    });
}


export const getSeconds = (secuence, progress) => {
    return (progress - secuence.timeAppear) + secuence.secondStart;
}

export const getQuestion = (questions, progress) => {
    const searchQuestion = questions.find(question => {
        const finalTimeAppear = question.timeAppearWithDuration !== null ? question.timeAppearWithDuration : question.timeAppear;
        return progress <= finalTimeAppear;
    });
    return searchQuestion ?? questions[questions.length - 1];
}

export const groupSegmentsWithMap = (segments) => {
    const formattedSequences = [];
    segments.reduce((res, seg, index) => {
        const duration = seg.SEGFIN - seg.SEGINI;
        const last = res[res.length - 1];
        if (!last || last.SEGFIN !== seg.SEGINI) {
            res.push({ ...seg, duration, OriginalGroupIndex: [index] });
        } else {
            last.SEGFIN = seg.SEGFIN;
            last.duration += duration;
            last.OriginalGroupIndex.push(index);
        }
        return res;
    }, formattedSequences);

    return formattedSequences;
};


